export const PipelineStatusStringMap = new Map<string, string>([
  // PLAT-4318 — **no 'DRAFT' row, deliberately.** Under the superseded design Pipeline.status
  // carried the token and was serialized raw, so it needed translating for display. Under the
  // draft-entity pivot a Draft row is never a Pipeline row and has no `status` field at all;
  // the merged list row synthesizes the display label directly (`DRAFT_ROW_LABEL`), and
  // ServerStringConverterPipe's `|| value` fallback passes it through untouched.
  ['PENDING_APPROVAL', 'Pending Approval'],
  ['PUBLISHED', 'Published'],
  ['APPROVED', 'Approved'],
  ['ERRORS', 'Errors'],
  ['QUEUED', 'Queued'],
  ['RUNNING', 'Running'],
  ['PAUSING', 'Pausing'],
  ['PAUSED', 'Paused'],
  ['RESUMING', 'Resuming'],
  ['PENDING_NEXT_RUN', 'Pending Next Run'],
]);
